// @ts-nocheck
import React from 'react';

const RodynnyiPage = () => {
  return (
    <section className="pt-2 pb-10">
      <div className="container md:px-[65px]">
        <div className="flex flex-col-reverse text-white md:flex-row">
          <div className="relative md:w-3/5 bg-[#A81414] md:h-[350px] px-6 py-2 md:p-8 md:rounded-tl-xl rounded-bl-xl max-md:rounded-br-xl">
            <h2 className="py-3 text-xl font-bold text-justify uppercase md:text-4xl hyphens-auto">Родинний Дім «Покрова» </h2>
            <div className="pt-3 pb-3 max-md:leading-5 md:pl-8 hyphens-auto">
              Родинний Дім «Покрова» розпочав свою історію ще в 2007 році при церкви Покрову Пресвятої Богородиці. Перші приміщення були реконструйовані з допомогою добродіїв з Ліхтенштейну, які знаходилися в самій вежі церкви. Все розпочалось з прийняття Романа, а також восьми інших дітей. З часом для родинного дому «Покрова» були виділені приміщення другого поверху будинку, де була можливість помістити близько сорока дітей. Тим часом на вул. Дорога Кривчицька 19, розпочалося будівництво нового помешкання для дітей і в 2014 році, розпочинаючи з червня, діти переїхали до свого нового і остаточного дому, де діти проживають, виховуються та готуються до повнолітнього життя.
            </div>

          </div>
          <div className="relative md:w-2/5">
            <div class="hidden md:block absolute md:top-1/2 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-t-[20px] border-b-[20px] border-l-[10px]
              md:border-t-[175px] md:border-b-[175px] md:border-l-[50px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
            </div>
            <img
              className="md:h-[350px] object-cover object-left rounded-tr-xl md:rounded-br-xl rounded-tl-xl md:rounded-tl-none"
              src="/images/dim.png"
              alt=""
            />
          </div>
        </div>
        <div className="mt-6 text-justify md:px-16 hyphens-auto">
          Родинний дім створений для забезпечення, утримання та виховання дітей-сиріт, дітей позбавлених батьківського піклування та дітей, які опинилися у важких життєвих обставинах, а також створює сприятливі умови, максимально наближених до домашніх, для організації життя, всестороннього та цілісного розвитку дітей. Виховуючи в них, взаємоповагу одне до одного, любов до ближнього, на основі християнських норм моралі і поведінки.
          Оточення кожного вихованця наповнене турботою і увагою, відповідно до салезіянської превентивної педагогічної системи виховання. Крім того, важливим аспектом є допомога вихованцям для своєчасного одержання необхідної освіти, підготовки до самостійного життя, вибору професії та праці.
        </div>
      
       
        <div className="flex flex-col justify-between py-4 md:px-16 md:flex-row">
          <div className="">
            <div className="text-[#A81414] font-bold pt-2 text-lg md:text-xl">
              Родинний Дім «Покрова»
            </div>
            <div className="flex my-2 max-md:ml-4">
              <div className="flex md:hidden border-[2px] border-[#A81414] mr-6">
              </div>
                <div className="hidden md:flex border-[2px] border-[#A81414]  mr-6">
          </div>
              <div>
                <div className="py-3">
                  Директор: о. Михайло Чабан, СДБ
                </div>
                <div className="">
                  Вул. Дорога Кривчицька, 19
                </div>
                <div className="">
                  Львів
                </div>
              </div>
            </div>
          </div>
        
        </div>
      </div>
    </section>
  );
};

export default RodynnyiPage;
